import vue from 'vue';
import { default as Component } from 'vue-class-component';

import { AppSidebar } from '../../template/app-sidebar';
import { DashboradNavigationBlock } from '../../template/dashborad-navigation-block';

@Component({
  template: require('./marks-page.html'),
  components: {
    'app-sidebar': AppSidebar,
    'dashborad-navigation-block': DashboradNavigationBlock,
  },
})
export class MarksPage extends vue {
  // Data
  get courseData() {
    return this.$store.state.course;
  }

  get lessonsData() {
    return this.$store.state.lessons;
  }

  get userProgress() {
    return this.$store.state.progress.filter((lesson) => {
      return !lesson.hasOwnProperty('reset');
    });;
  }

  // Preloader
  get loading() {
    return this.loadingUser && this.loadingLesson;
  }

  get loadingUser() {
    return this.$store.state.loadingUser;
  }

  get loadingLesson() {
    return this.userProgress.length > -1;
  }

  isQuiz(type) {
    return (type === 'App\\Models\\Quiz') ? true : false;
  }

  // Logic
  unitResultPercentage(unit) {
    let total = 0;

    let unitLessonsPass = this.userProgress.filter((lesson) => {
      return lesson.unitId === unit.id && lesson.type === 'App\\Models\\Quiz';
    });

    let unitLessons = this.lessonsData.filter((lesson) => {
      return lesson.unitId === unit.id && lesson.type === 'App\\Models\\Quiz';
    });

    if (unitLessonsPass.length > 0) {
      unitLessonsPass.forEach((unit, i) => {
        total += unit.resultPercentage;
      });
    }
    if (unitLessons.length > 0) {
      // Calculating percentage only by passed quizes
      return Math.round(total / unitLessonsPass.length);
    }

    return 0;
  }


  lessonResultPercentage(lesson) {
    let lessonPercentage = this.userProgress.find((key) => {
        return key.id === lesson.id && key.type === 'App\\Models\\Quiz' && !key.hasOwnProperty('reset');;
    });
    if (lessonPercentage){
      return lessonPercentage.resultPercentage;
    }
  }

  blocksResultPercentage(block) {
    let units = [];
    let lessons = [];
    let total = 0;
    let unitsfiltered = [];
    
    block.units.forEach((unit) => {
      let blocksUnits = this.userProgress.filter((lesson) => {
        return lesson.unitId === unit.id && lesson.type === 'App\\Models\\Quiz' && !lesson.hasOwnProperty('reset');
      });
      // here was a mistake, system take only the first exam in the unit
      blocksUnits.forEach((blocksUnit, i) => {
        units.push(blocksUnit);
      });
    });

    units.forEach((unit, i) => {
      if (units[i]) {
        total += units[i].resultPercentage;
      }
    });
    
    // filter units by passed only
    unitsfiltered = units.filter((unit) => {
      return unit !== undefined;
    })

    return Math.round(total / unitsfiltered.length);
  }
    //current Score calculation

    get currentScore(){
      let correct = 0;
      let total = 0;
  
      let quizResults = this.userProgress.filter((lesson) => {
        return lesson.type === 'App\\Models\\Quiz' && lesson.resultPercentage != undefined;
      });
      if (quizResults.length > 0) {
        quizResults.forEach(quiz => {
          correct += parseInt(quiz.result[0]);
          total += parseInt(quiz.result[1]);
        });
        return Math.round(correct/total*100);
      }
      return 0;
    }
}
